import { render, staticRenderFns } from "./PaypalSuccessPageView.vue?vue&type=template&id=0712e331&"
import script from "./PaypalSuccessPageView.vue?vue&type=script&lang=js&"
export * from "./PaypalSuccessPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports